var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48, _circle49, _circle50, _circle51, _circle52, _circle53, _circle54, _circle55, _circle56, _circle57, _circle58, _circle59, _circle60, _circle61, _circle62, _circle63, _circle64, _circle65, _circle66, _circle67, _circle68, _circle69, _circle70, _circle71, _circle72, _circle73, _circle74, _circle75, _circle76, _circle77, _circle78, _circle79, _circle80, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 106,
    viewBox: "0 0 134 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 1.66667 104.001)",
    fill: "url(#paint0_linear_740_5028)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3307,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 16.3307 104.001)",
    fill: "url(#paint1_linear_740_5028)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0026,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 31.0026 104.001)",
    fill: "url(#paint2_linear_740_5028)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 45.6667 104.001)",
    fill: "url(#paint3_linear_740_5028)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3307,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 60.3307 104.001)",
    fill: "url(#paint4_linear_740_5028)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 88.6667 104.001)",
    fill: "url(#paint5_linear_740_5028)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 117.667 104.001)",
    fill: "url(#paint6_linear_740_5028)"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 74.6667 104.001)",
    fill: "url(#paint7_linear_740_5028)"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.003,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 103.003 104.001)",
    fill: "url(#paint8_linear_740_5028)"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.003,
    cy: 104.001,
    r: 1.66667,
    transform: "rotate(-90 132.003 104.001)",
    fill: "url(#paint9_linear_740_5028)"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 1.66667 89.3336)",
    fill: "url(#paint10_linear_740_5028)"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3346,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 16.3346 89.3336)",
    fill: "url(#paint11_linear_740_5028)"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9987,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 30.9987 89.3336)",
    fill: "url(#paint12_linear_740_5028)"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 89.3338,
    r: 1.66667,
    transform: "rotate(-90 45.6667 89.3338)",
    fill: "url(#paint13_linear_740_5028)"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3307,
    cy: 89.3346,
    r: 1.66667,
    transform: "rotate(-90 60.3307 89.3346)",
    fill: "url(#paint14_linear_740_5028)"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 88.6667 89.3336)",
    fill: "url(#paint15_linear_740_5028)"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 117.667 89.3336)",
    fill: "url(#paint16_linear_740_5028)"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 89.3336,
    r: 1.66667,
    transform: "rotate(-90 74.6667 89.3336)",
    fill: "url(#paint17_linear_740_5028)"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.999,
    cy: 89.3346,
    r: 1.66667,
    transform: "rotate(-90 102.999 89.3346)",
    fill: "url(#paint18_linear_740_5028)"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 89.3346,
    r: 1.66667,
    transform: "rotate(-90 131.999 89.3346)",
    fill: "url(#paint19_linear_740_5028)"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 74.6676,
    r: 1.66667,
    transform: "rotate(-90 1.66667 74.6676)",
    fill: "url(#paint20_linear_740_5028)"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 1.66667 31.0006)",
    fill: "url(#paint21_linear_740_5028)"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3307,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 16.3307 74.6666)",
    fill: "url(#paint22_linear_740_5028)"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3307,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 16.3307 31.0006)",
    fill: "url(#paint23_linear_740_5028)"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0026,
    cy: 74.6676,
    r: 1.66667,
    transform: "rotate(-90 31.0026 74.6676)",
    fill: "url(#paint24_linear_740_5028)"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 31.0026,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 31.0026 31.0006)",
    fill: "url(#paint25_linear_740_5028)"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 74.6676,
    r: 1.66667,
    transform: "rotate(-90 45.6667 74.6676)",
    fill: "url(#paint26_linear_740_5028)"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 45.6667 31.0006)",
    fill: "url(#paint27_linear_740_5028)"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3307,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 60.3307 74.6666)",
    fill: "url(#paint28_linear_740_5028)"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3346,
    cy: 30.9996,
    r: 1.66667,
    transform: "rotate(-90 60.3346 30.9996)",
    fill: "url(#paint29_linear_740_5028)"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 88.6667 74.6666)",
    fill: "url(#paint30_linear_740_5028)"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 30.9996,
    r: 1.66667,
    transform: "rotate(-90 88.6667 30.9996)",
    fill: "url(#paint31_linear_740_5028)"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 117.667 74.6666)",
    fill: "url(#paint32_linear_740_5028)"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 117.667 31.0006)",
    fill: "url(#paint33_linear_740_5028)"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 74.6667 74.6666)",
    fill: "url(#paint34_linear_740_5028)"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 30.9996,
    r: 1.66667,
    transform: "rotate(-90 74.6667 30.9996)",
    fill: "url(#paint35_linear_740_5028)"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.999,
    cy: 74.6666,
    r: 1.66667,
    transform: "rotate(-90 102.999 74.6666)",
    fill: "url(#paint36_linear_740_5028)"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.999,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 102.999 31.0006)",
    fill: "url(#paint37_linear_740_5028)"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 74.6676,
    r: 1.66667,
    transform: "rotate(-90 131.999 74.6676)",
    fill: "url(#paint38_linear_740_5028)"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 31.0006,
    r: 1.66667,
    transform: "rotate(-90 131.999 31.0006)",
    fill: "url(#paint39_linear_740_5028)"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 1.66667 60.0006)",
    fill: "url(#paint40_linear_740_5028)"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 1.66667 16.3336)",
    fill: "url(#paint41_linear_740_5028)"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3307,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 16.3307 60.0006)",
    fill: "url(#paint42_linear_740_5028)"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3307,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 16.3307 16.3336)",
    fill: "url(#paint43_linear_740_5028)"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9987,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 30.9987 60.0006)",
    fill: "url(#paint44_linear_740_5028)"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9987,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 30.9987 16.3336)",
    fill: "url(#paint45_linear_740_5028)"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 45.6667 60.0006)",
    fill: "url(#paint46_linear_740_5028)"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 45.6667 16.3336)",
    fill: "url(#paint47_linear_740_5028)"
  })), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3346,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 60.3346 60.0006)",
    fill: "url(#paint48_linear_740_5028)"
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3307,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 60.3307 16.3336)",
    fill: "url(#paint49_linear_740_5028)"
  })), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 88.6667 60.0006)",
    fill: "url(#paint50_linear_740_5028)"
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 88.6667 16.3336)",
    fill: "url(#paint51_linear_740_5028)"
  })), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 117.667 60.0006)",
    fill: "url(#paint52_linear_740_5028)"
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 16.3338,
    r: 1.66667,
    transform: "rotate(-90 117.667 16.3338)",
    fill: "url(#paint53_linear_740_5028)"
  })), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 74.6667 60.0006)",
    fill: "url(#paint54_linear_740_5028)"
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 74.6667 16.3336)",
    fill: "url(#paint55_linear_740_5028)"
  })), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.999,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 102.999 60.0006)",
    fill: "url(#paint56_linear_740_5028)"
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.003,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 103.003 16.3336)",
    fill: "url(#paint57_linear_740_5028)"
  })), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 60.0006,
    r: 1.66667,
    transform: "rotate(-90 131.999 60.0006)",
    fill: "url(#paint58_linear_740_5028)"
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 16.3336,
    r: 1.66667,
    transform: "rotate(-90 131.999 16.3336)",
    fill: "url(#paint59_linear_740_5028)"
  })), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 1.66667 45.3336)",
    fill: "url(#paint60_linear_740_5028)"
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.66667,
    cy: 1.66756,
    r: 1.66667,
    transform: "rotate(-90 1.66667 1.66756)",
    fill: "url(#paint61_linear_740_5028)"
  })), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3346,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 16.3346 45.3336)",
    fill: "url(#paint62_linear_740_5028)"
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3346,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 16.3346 1.66659)",
    fill: "url(#paint63_linear_740_5028)"
  })), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9987,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 30.9987 45.3336)",
    fill: "url(#paint64_linear_740_5028)"
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.9987,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 30.9987 1.66659)",
    fill: "url(#paint65_linear_740_5028)"
  })), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 45.3338,
    r: 1.66667,
    transform: "rotate(-90 45.6667 45.3338)",
    fill: "url(#paint66_linear_740_5028)"
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6667,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 45.6667 1.66659)",
    fill: "url(#paint67_linear_740_5028)"
  })), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3346,
    cy: 45.3346,
    r: 1.66667,
    transform: "rotate(-90 60.3346 45.3346)",
    fill: "url(#paint68_linear_740_5028)"
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.3307,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 60.3307 1.66659)",
    fill: "url(#paint69_linear_740_5028)"
  })), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 88.6667 45.3336)",
    fill: "url(#paint70_linear_740_5028)"
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.6667,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 88.6667 1.66659)",
    fill: "url(#paint71_linear_740_5028)"
  })), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 117.667 45.3336)",
    fill: "url(#paint72_linear_740_5028)"
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.667,
    cy: 1.66756,
    r: 1.66667,
    transform: "rotate(-90 117.667 1.66756)",
    fill: "url(#paint73_linear_740_5028)"
  })), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 74.6667 45.3336)",
    fill: "url(#paint74_linear_740_5028)"
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.6667,
    cy: 1.66659,
    r: 1.66667,
    transform: "rotate(-90 74.6667 1.66659)",
    fill: "url(#paint75_linear_740_5028)"
  })), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    cx: 102.999,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 102.999 45.3336)",
    fill: "url(#paint76_linear_740_5028)"
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.003,
    cy: 1.66756,
    r: 1.66667,
    transform: "rotate(-90 103.003 1.66756)",
    fill: "url(#paint77_linear_740_5028)"
  })), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 45.3336,
    r: 1.66667,
    transform: "rotate(-90 131.999 45.3336)",
    fill: "url(#paint78_linear_740_5028)"
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.999,
    cy: 1.66756,
    r: 1.66667,
    transform: "rotate(-90 131.999 1.66756)",
    fill: "url(#paint79_linear_740_5028)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_5028",
    x1: 0.771226,
    y1: 104.219,
    x2: 3.30938,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_740_5028",
    x1: 15.4353,
    y1: 104.219,
    x2: 17.9734,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_740_5028",
    x1: 30.1072,
    y1: 104.219,
    x2: 32.6453,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_740_5028",
    x1: 44.7712,
    y1: 104.219,
    x2: 47.3094,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_740_5028",
    x1: 59.4353,
    y1: 104.219,
    x2: 61.9734,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_740_5028",
    x1: 87.7712,
    y1: 104.219,
    x2: 90.3094,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_740_5028",
    x1: 116.771,
    y1: 104.219,
    x2: 119.309,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_740_5028",
    x1: 73.7712,
    y1: 104.219,
    x2: 76.3094,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_740_5028",
    x1: 102.107,
    y1: 104.219,
    x2: 104.645,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_740_5028",
    x1: 131.107,
    y1: 104.219,
    x2: 133.645,
    y2: 104.218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_740_5028",
    x1: 0.771226,
    y1: 89.5515,
    x2: 3.30938,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_740_5028",
    x1: 15.4392,
    y1: 89.5515,
    x2: 17.9773,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_740_5028",
    x1: 30.1033,
    y1: 89.5515,
    x2: 32.6414,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_740_5028",
    x1: 44.7712,
    y1: 89.5518,
    x2: 47.3094,
    y2: 89.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_740_5028",
    x1: 59.4353,
    y1: 89.5525,
    x2: 61.9734,
    y2: 89.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_740_5028",
    x1: 87.7712,
    y1: 89.5515,
    x2: 90.3094,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_740_5028",
    x1: 116.771,
    y1: 89.5515,
    x2: 119.309,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_740_5028",
    x1: 73.7712,
    y1: 89.5515,
    x2: 76.3094,
    y2: 89.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_740_5028",
    x1: 102.103,
    y1: 89.5525,
    x2: 104.641,
    y2: 89.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_740_5028",
    x1: 131.103,
    y1: 89.5525,
    x2: 133.641,
    y2: 89.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_740_5028",
    x1: 0.771226,
    y1: 74.8855,
    x2: 3.30938,
    y2: 74.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_740_5028",
    x1: 0.771226,
    y1: 31.2185,
    x2: 3.30938,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_740_5028",
    x1: 15.4353,
    y1: 74.8846,
    x2: 17.9734,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_740_5028",
    x1: 15.4353,
    y1: 31.2185,
    x2: 17.9734,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_740_5028",
    x1: 30.1072,
    y1: 74.8855,
    x2: 32.6453,
    y2: 74.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_740_5028",
    x1: 30.1072,
    y1: 31.2185,
    x2: 32.6453,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_740_5028",
    x1: 44.7712,
    y1: 74.8855,
    x2: 47.3094,
    y2: 74.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_740_5028",
    x1: 44.7712,
    y1: 31.2185,
    x2: 47.3094,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_740_5028",
    x1: 59.4353,
    y1: 74.8846,
    x2: 61.9734,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_740_5028",
    x1: 59.4392,
    y1: 31.2176,
    x2: 61.9773,
    y2: 31.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_740_5028",
    x1: 87.7712,
    y1: 74.8846,
    x2: 90.3094,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_740_5028",
    x1: 87.7712,
    y1: 31.2176,
    x2: 90.3094,
    y2: 31.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_740_5028",
    x1: 116.771,
    y1: 74.8846,
    x2: 119.309,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_740_5028",
    x1: 116.771,
    y1: 31.2185,
    x2: 119.309,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_740_5028",
    x1: 73.7712,
    y1: 74.8846,
    x2: 76.3094,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_740_5028",
    x1: 73.7712,
    y1: 31.2176,
    x2: 76.3094,
    y2: 31.217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_740_5028",
    x1: 102.103,
    y1: 74.8846,
    x2: 104.641,
    y2: 74.8839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_740_5028",
    x1: 102.103,
    y1: 31.2185,
    x2: 104.641,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_740_5028",
    x1: 131.103,
    y1: 74.8855,
    x2: 133.641,
    y2: 74.8849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_740_5028",
    x1: 131.103,
    y1: 31.2185,
    x2: 133.641,
    y2: 31.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_740_5028",
    x1: 0.771226,
    y1: 60.2185,
    x2: 3.30938,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_740_5028",
    x1: 0.771226,
    y1: 16.5515,
    x2: 3.30938,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_740_5028",
    x1: 15.4353,
    y1: 60.2185,
    x2: 17.9734,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_740_5028",
    x1: 15.4353,
    y1: 16.5515,
    x2: 17.9734,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_740_5028",
    x1: 30.1033,
    y1: 60.2185,
    x2: 32.6414,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_740_5028",
    x1: 30.1033,
    y1: 16.5515,
    x2: 32.6414,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_740_5028",
    x1: 44.7712,
    y1: 60.2185,
    x2: 47.3094,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_740_5028",
    x1: 44.7712,
    y1: 16.5515,
    x2: 47.3094,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_740_5028",
    x1: 59.4392,
    y1: 60.2185,
    x2: 61.9773,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_740_5028",
    x1: 59.4353,
    y1: 16.5515,
    x2: 61.9734,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_740_5028",
    x1: 87.7712,
    y1: 60.2185,
    x2: 90.3094,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_740_5028",
    x1: 87.7712,
    y1: 16.5515,
    x2: 90.3094,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_740_5028",
    x1: 116.771,
    y1: 60.2185,
    x2: 119.309,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_740_5028",
    x1: 116.771,
    y1: 16.5518,
    x2: 119.309,
    y2: 16.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_740_5028",
    x1: 73.7712,
    y1: 60.2185,
    x2: 76.3094,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_740_5028",
    x1: 73.7712,
    y1: 16.5515,
    x2: 76.3094,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_740_5028",
    x1: 102.103,
    y1: 60.2185,
    x2: 104.641,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_740_5028",
    x1: 102.107,
    y1: 16.5515,
    x2: 104.645,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_740_5028",
    x1: 131.103,
    y1: 60.2185,
    x2: 133.641,
    y2: 60.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_740_5028",
    x1: 131.103,
    y1: 16.5515,
    x2: 133.641,
    y2: 16.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_740_5028",
    x1: 0.771226,
    y1: 45.5515,
    x2: 3.30938,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_740_5028",
    x1: 0.771226,
    y1: 1.88553,
    x2: 3.30938,
    y2: 1.88492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_740_5028",
    x1: 15.4392,
    y1: 45.5515,
    x2: 17.9773,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_740_5028",
    x1: 15.4392,
    y1: 1.88455,
    x2: 17.9773,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_740_5028",
    x1: 30.1033,
    y1: 45.5515,
    x2: 32.6414,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_740_5028",
    x1: 30.1033,
    y1: 1.88455,
    x2: 32.6414,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_740_5028",
    x1: 44.7712,
    y1: 45.5518,
    x2: 47.3094,
    y2: 45.5512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_740_5028",
    x1: 44.7712,
    y1: 1.88455,
    x2: 47.3094,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_740_5028",
    x1: 59.4392,
    y1: 45.5525,
    x2: 61.9773,
    y2: 45.5519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_740_5028",
    x1: 59.4353,
    y1: 1.88455,
    x2: 61.9734,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_740_5028",
    x1: 87.7712,
    y1: 45.5515,
    x2: 90.3094,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_740_5028",
    x1: 87.7712,
    y1: 1.88455,
    x2: 90.3094,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_740_5028",
    x1: 116.771,
    y1: 45.5515,
    x2: 119.309,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_740_5028",
    x1: 116.771,
    y1: 1.88553,
    x2: 119.309,
    y2: 1.88492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_740_5028",
    x1: 73.7712,
    y1: 45.5515,
    x2: 76.3094,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_740_5028",
    x1: 73.7712,
    y1: 1.88455,
    x2: 76.3094,
    y2: 1.88394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_740_5028",
    x1: 102.103,
    y1: 45.5515,
    x2: 104.641,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_740_5028",
    x1: 102.107,
    y1: 1.88553,
    x2: 104.645,
    y2: 1.88492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_740_5028",
    x1: 131.103,
    y1: 45.5515,
    x2: 133.641,
    y2: 45.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_740_5028",
    x1: 131.103,
    y1: 1.88553,
    x2: 133.641,
    y2: 1.88492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.a73bb9bb7a6064216b39eacb97a71e71.svg";
export { ForwardRef as ReactComponent };